/* Чергування карток у «Найчастіше купують з».

   Сторінку Shopify кешує: HTML однаковий для всіх, хто його відкриває. Тому
   «щоразу різні» можна зробити лише тут, у браузері, в момент показу.

   Як тасуємо. Не навмання, а з вагою: картка з місцем r у списку отримує вагу
   1 / (1 + 0.35·r). Для кожної беремо випадкове число u і рахуємо ключ u^(1/вага)
   — це стандартний спосіб зваженої випадкової вибірки (Efraimidis–Spirakis).
   Сортуємо за ключем. У підсумку перша за схожістю картка потрапляє на
   початок найчастіше, десята — рідше, але теж потрапляє. Людина щоразу
   бачить інше, а найсхожіше — найчастіше.

   Закріплені картки (data-pin) не рухаємо — вони завжди перші.

   Файл може підключитися двічі, тому все всередині функції і з позначкою
   «вже перетасовано». */
(function () {
	function weightedShuffle(items) {
		return items
			.map(function (el) {
				var rank = parseInt(el.getAttribute('data-rank'), 10) || 0;
				var weight = 1 / (1 + 0.35 * rank);
				var u = Math.random() || 1e-9;
				return { el: el, key: Math.pow(u, 1 / weight) };
			})
			.sort(function (a, b) {
				return b.key - a.key;
			})
			.map(function (x) {
				return x.el;
			});
	}

	function rotate(track) {
		if (track.hasAttribute('data-rotated')) return;
		track.setAttribute('data-rotated', '');

		var rest = Array.prototype.filter.call(track.children, function (el) {
			return !el.hasAttribute('data-pin');
		});
		if (rest.length < 2) return;

		/* Картки НЕ переставляємо, а замінюємо свіжими копіями.

		   Причина в темі: <product-card> у connectedCallback вішає обробник на
		   «Додати в корзину» і ніколи його не знімає. Для браузера переставити
		   елемент = від'єднати й приєднати знову, тож кожне переставлення додає
		   ще один обробник. Переставлена картка мала два — і один клік клав у
		   кошик ДВІ штуки. Свіжа копія приєднується рівно раз і отримує рівно
		   один обробник, а старі картки зникають разом зі своїми.

		   Закріплені (data-pin) не чіпаємо взагалі — вони вже на своїх місцях. */
		var shuffled = weightedShuffle(rest).map(function (el) {
			return el.cloneNode(true);
		});
		rest.forEach(function (el) {
			el.remove();
		});
		shuffled.forEach(function (el) {
			track.appendChild(el);
		});
		track.scrollLeft = 0;
	}

	function run() {
		var tracks = document.querySelectorAll('[data-reco-rotate]');
		Array.prototype.forEach.call(tracks, rotate);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
})();
